import z from 'zod';

/** Error has `errorCode` `'access_denied'`. */
export const isAccessDeniedError = (error: unknown): boolean =>
  z.object({ errorCode: z.string() }).safeParse(error).data?.errorCode ===
  'access_denied';
